import {
  AUTHENTICATE_FIGMA_REQUEST, AUTHTENTICATING_FIGMA_SUCCEEDED, AUTHTENTICATING_FIGMA_FAILED,
  FETCH_FIGMA_FRAMES_REQUEST, FETCHING_FIGMA_FRAMES_SUCCEEDED, FETCHING_FIGMA_FRAMES_FAILED, 
  UPDATE_FIGMA_SELECTION, INVALIDATE_FIGMA
} from 'constants/actionTypes';

import axios from 'axios';
import { createAction } from 'redux-actions';
import buildUrl from 'build-url';
import { call, put, takeEvery } from 'redux-saga/effects';

const apiUrl = `${process.env.REACT_APP_CLEVERSTORY_API_URL}/api/1.0`;
const FIGMA_BASE_URL = `${apiUrl}/integrations/figma`;
const FIGMA_AUTHENTICATION_URL = `${FIGMA_BASE_URL}/authenticate`;

/*
* Authenticate Figma
*/
export const authenticateFigma = createAction(AUTHENTICATE_FIGMA_REQUEST, (code, workspace, callback) => {
  return {
    code: code,
    workspace: workspace,
    callback: callback
  }
})

const authenticateFigmaSucceeded = createAction(AUTHTENTICATING_FIGMA_SUCCEEDED, (response) => {
  return response;
})

const authenticateFigmaFailed = createAction(AUTHTENTICATING_FIGMA_FAILED, (error) => {
  return error;
})

function* authenticateFigmaSaga(action) {
  const { code, workspace, callback } = action.payload;

  let params = {
    code: code
  }

  const headers = {
    'CS-WORKSPACE-ID': workspace
  }

  let url = buildUrl(FIGMA_AUTHENTICATION_URL, {
    queryParams: params
  });

  const authenticateFigmaAPI = () => {
    return axios.post(url, {} , {
      headers: headers,
    }).then(response => response.data);
  }

  try {
    const response = yield call(authenticateFigmaAPI);
    if (response) {
      yield put(authenticateFigmaSucceeded(response));
    }
    if (callback) {
      callback(response);
    }
  } catch (error) {
    yield put(authenticateFigmaFailed(error));
  }
}

/*
* Frames & Fonts Figma
*/
export const fetchFigmaFrames = createAction(FETCH_FIGMA_FRAMES_REQUEST, (fileUid, fileLink) => {
  return {
    fileUid: fileUid,
    fileLink: fileLink
  };
})

export const fetchingFigmaFramesSucceeded = createAction(FETCHING_FIGMA_FRAMES_SUCCEEDED, (fileUid, response) => {
  return {
    fileUid: fileUid,
    response: response
  };
})

export const fetchingFigmaFramesFailed = createAction(FETCHING_FIGMA_FRAMES_FAILED, (fileUid, error) => {
  return {
    fileUid: fileUid,
    error: error
  };
})

function* fetchFigmaFramesSaga(action) {
  const { fileUid } = action.payload;

  let url = buildUrl(FIGMA_BASE_URL, {
    path: `/${fileUid}/frames`
  });

  const fetchFigmaFramesAPI = () => {
    return axios.get(url).then(response => response.data);
  }

  try {
    const response = yield call(fetchFigmaFramesAPI);
    if (response) {
      yield put(fetchingFigmaFramesSucceeded(fileUid, response));
    }

  } catch (error) {
    yield put(fetchingFigmaFramesFailed(fileUid, error));
  }
}

/*
Figma Update Selection
*/

export const updateSelection = createAction(UPDATE_FIGMA_SELECTION, (request) => {
  return {
    request: request
  }
})

/*
Invalidate Figma
*/

export const invalidateFigma = createAction(INVALIDATE_FIGMA);

export default function* figmaSaga() {
  yield takeEvery(AUTHENTICATE_FIGMA_REQUEST, authenticateFigmaSaga);
  yield takeEvery(FETCH_FIGMA_FRAMES_REQUEST, fetchFigmaFramesSaga);
}
